export default __webpack_public_path__ + "static/media/1158.260dfe54.png";